import React from 'react';
import { Icon, TextInput } from '@octano/global-ui';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';
import { Row, Col } from 'reactstrap';

interface SortableOptionProps {
  field: { fieldId: string; description: string };
  index: number;
  label: string;
  control: any;
  remove: (index: number) => void;
  msgValidations: any;
  disabled?: boolean;
}

const SortableOption: React.FC<SortableOptionProps> = ({
  field,
  index,
  label,
  control,
  remove,
  msgValidations,
  disabled,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: field.fieldId });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
  };

  return (
    <div ref={setNodeRef} style={style} className="mb-2">
      <Row className="d-flex align-items-center">
        <Col
          xs="auto"
          className="d-flex align-items-center justify-content-center rounded"
          style={{
            backgroundColor: '#f0f0f0',
            width: 50,
            height: 65,
            marginLeft: 15,
            marginBottom: 15,
          }}
        >
          <div style={{ fontWeight: 'bold' }}>{index + 1}</div>
        </Col>

        <Col style={{ marginLeft: -10 }}>
          <TextInput
            name={`scaleOptions.${index}.description`}
            control={control}
            label={label}
            placeholder=""
            rules={{ required: msgValidations.required }}
            defaultValue={field.description}
          />
        </Col>

        <Col
          xs="auto"
          style={{
            marginBottom: 15,
            cursor: 'pointer',
            marginLeft: -14,
            marginRight: -10,
          }}
          onClick={() => remove(index)}
        >
          <button disabled={disabled} className="btn">
            <Icon name="trash" />
          </button>
        </Col>

        <Col
          xs="auto"
          {...attributes}
          {...listeners}
          style={{
            marginBottom: 15,
            cursor: 'grab',
          }}
        >
          <Icon name="drag_dots" />
        </Col>
      </Row>
    </div>
  );
};

export default SortableOption;
